










































































import { Component, Vue } from "vue-property-decorator";
import { MetaInfo } from "vue-meta";

@Component({
  metaInfo(): MetaInfo {
    return {
      title: "About Us",
    };
  },
})
export default class About extends Vue {}
